export const getFileExtension = (fileName: string) => {
  if (!fileName) return "";
  const fileExtensionRegex = new RegExp("\\.\\w+$");
  const fileExtension = fileName.match(fileExtensionRegex)?.[0];
  return fileExtension?.slice(1) ?? "";
};
